import { getStartOfDay, getEndOfDay } from '@travelata-libs/utils';
import {
  type CalendarEvents,
  type CalendarSystemModelValue,
  type CalendarAPI,
  type DateTimestamp,
} from '../Calendar.types';
import { getLastDayBySpan, sortRange } from '../utils/date';

function onDaySingleClick(day: DateTimestamp, calendar: CalendarAPI) {
  const startDate = getStartOfDay(day);

  const value = {
    start: startDate,
    end: startDate,
  } as CalendarSystemModelValue;

  const { systemModelValue } = calendar;
  systemModelValue.value = value;
}

export function useSingleSelectionCalendarEvents(): CalendarEvents {
  return {
    onDayClick: onDaySingleClick,
    onDayHover: null,
  };
}

function onRangeStartClick(day: DateTimestamp, calendar: CalendarAPI) {
  const newRange: CalendarSystemModelValue = {
    start: getStartOfDay(day),
    end: getEndOfDay(day),
  };

  const { calendarEvents, systemModelValue } = calendar;
  systemModelValue.value = newRange;
  calendarEvents.value = useRangeEndSelectionCalendarEvents(day);
}

function useRangeStartSelectionCalendarEvents(): CalendarEvents {
  return {
    onDayClick: onRangeStartClick,
    onDayHover: null,
  };
}

function useRangeEndSelectionCalendarEvents(firstDay: DateTimestamp): CalendarEvents {
  function onRangeEndClick(day: DateTimestamp, calendar: CalendarAPI, span?: number) {
    const lastDay = getLastDayBySpan(day, firstDay, span);

    const newRange = sortRange({
      start: getStartOfDay(firstDay),
      end: getEndOfDay(lastDay),
    }) as CalendarSystemModelValue;

    const { calendarEvents, systemModelValue } = calendar;
    systemModelValue.value = newRange;
    calendarEvents.value = useRangeStartSelectionCalendarEvents();
  }

  function onRangeDayHover(day: DateTimestamp, calendar: CalendarAPI, span?: number) {
    const lastDay = getLastDayBySpan(day, firstDay, span);

    const newRange = sortRange({
      start: getStartOfDay(firstDay),
      end: getEndOfDay(lastDay),
    }) as CalendarSystemModelValue;

    const { systemModelValue } = calendar;
    systemModelValue.value = newRange;
  }

  return {
    onDayClick: onRangeEndClick,
    onDayHover: onRangeDayHover,
  };
}

export function getCalendarEvents(range: boolean) {
  return range ? useRangeStartSelectionCalendarEvents() : useSingleSelectionCalendarEvents();
}
